import { cn } from '@crossnokaye/ux-common';

import { Stack } from '@/ux-common/components/stack/stack';

interface FacilityFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const FacilityFrame = ({ children, className, ...props }: FacilityFrameProps) => {
  return (
    <Stack className={cn('stack-none @container/facility h-full relative', className)} {...props}>
      {children}
    </Stack>
  );
};
